// extracted by mini-css-extract-plugin
module.exports = {"marketIcon":"AssetTypeFilter_marketIcon__p0kRY","listingsIcon":"AssetTypeFilter_listingsIcon__GoImb","toggleFlex":"AssetTypeFilter_toggleFlex__zADd_"};